export const TIMEOUT_AGREMENTS = 600000; // 10 mins

export const PAGE = {
  LOGIN: "login",
  LOADING: "loading",
  AGREEMENT: "agreement",
  ABOUT_APP: "aboutapp",
  STOP_CODE: "stopcode",
  DIALOG: "dialog",
};

export const INITIAL_STATE = {
  page: "login", //aboutapp, agreement, stopcode, dialog
  logo: "",
  text01: "", // AboutApp
  text02: "", // Agreement
  screen_counter: 0,
  number_of_attempts: 1,
  error: false,
  errorMessage: null,
  loading: false,
  appid: "",
  appcode: "",
  user: {
    SNAME: null,
    SNICK: null,
    TGENDER: null,
    SGENDER: null,
    SMAIL: null,
    STEL: null,
  },
  stopcode: 0,
  logrow: {},
  appdata_old: {},
  appdata: {
    TESTER: {
      TEMOTIKONID: 1,
      TTEXT: {
        TCONTENT: "Jaký může také ukazuje, že mají ",
        TLOOK: "SPEAK",
      },
      TSPKID: "3Tasdfasf",
    },
    PERSONA: {
      PEMOTIKONID: 1,
      PTEXT: {
        ANSWER: [
          {
            AID: "1",
            ACONTENT: "Jaký může",
            ATYPE: "P",
            ACOLOR: 1,
            ASPKID: "1asdfghjkl",
          },
          {
            AID: "2",
            ACONTINUE: "2",
            ATYPE: "P",
            ACONTENT:
              "Jaký může být vysledek hry? Nejvíce hra přitahovala VZTAHOVÉ ŠÉFY, kteří jsou ve ",
            ACOLOR: 2,
            ASPKID: "2asdfghjkl",
          },
          {
            AID: "3",
            ACONTINUE: "2",
            ATYPE: "P",
            ACONTENT:
              "Jaký může být vysledek hry? Nejvíce hra přitahovala VZTAHOVÉ ŠÉFY, kteří jsou ve ",
            ACOLOR: 3,
          },
          {
            AID: "4",
            ATYPE: "P",
            ACONTINUE: "2",
            ACONTENT:
              "Jaký může být vysledek hry? Nejvíce hra přitahovala VZTAHOVÉ ŠÉFY, kteří jsou ve ",
            ACOLOR: 4,
          },
        ],
      },
    },
    STRESS: {
      STIME: 100,
      SALERT: 20,
      SALERID: 2,
    },
    FRAME: {
      FCOLOR: 100,
      FALERT: 20,
      FALERID: 1,
    },
    STOPCODE: 0, // nemenit
    STOPERR: "Congratulations! " + "\n",
  },
  idcontext: "",
  theme: localStorage.getItem("theme") || "light",
};

export const INITIAL_STATE_LOGIN_FORM = {
  appid: "",
  nick: "",
  email: "",
  tgender: "",
  hideAppId: false,
  hideEmail: false,
  title: "Hello, let's go!",
  idcontext: "",
};

export const TIMEOUT_FOR_SEND_ANSWER = 1500; // 1.5 seconds
